import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useDecode from "hooks/useDecode";
import useGetEconomicSheets from "services/recordSheets/useGetEconomicSheets";
import LoaderMin from "components/blocks/Loader/LoaderMin";
import { SheetPage, SheetHero, SheetPill, SheetSection, SheetGrid, SheetField, formatText, formatDate, formatCurrency } from "../SheetLayout";

const Recobro: React.FC = () => {
  const params = useParams<{ detailId: string; id: string }>();
  const recobroId = params.detailId?.split("__")[1];
  const prestacionId = params.id.split("_")[1];
  const { getRecovery, dataEconomicSheet: d, loadingEconomicSheet, errorEconomicSheet } = useGetEconomicSheets();
  const userId = useDecode("token")?.extension_id;

  useEffect(() => { getRecovery(userId, prestacionId, recobroId); }, []);

  if (loadingEconomicSheet) return <section className="container"><LoaderMin /></section>;
  if (errorEconomicSheet) return <section className="container"><p className="loader-text">Lo sentimos, se ha producido un error.</p></section>;
  if (!d) return <section className="container"><p className="loader-text">No hay datos para mostrar.</p></section>;

  return (
    <SheetPage>
      <SheetHero
        title="Recobro"
        icon="refresh-cw"
        pills={<>
          <SheetPill label="Tipo" value={formatText(d.tipoRecobro)} />
          <SheetPill label="Estado" value={formatText(d.estadoRecobro)} />
        </>}
      />

      <SheetSection title="Datos Recobro" icon="file-text">
        <SheetGrid>
          <SheetField label="Código"          value={formatText(d.codigo)} />
          <SheetField label="Fecha Registro"  value={formatDate(d.fechaRegistro)} />
          <SheetField label="Tipo Recobro"    value={formatText(d.tipoRecobro)} />
          <SheetField label="Recobrante"      value={formatText(d.recobranteDescripcion)} wide />
        </SheetGrid>
      </SheetSection>

      <SheetSection title="Detalles Recobro" icon="euro">
        <SheetGrid cols={3}>
          <SheetField label="Total Cantidad Reclamada"  value={formatCurrency(d.cantidadReclamada)} />
          <SheetField label="Total Cantidad Abonada"    value={formatCurrency(d.cantidadRecobrada)} />
          <SheetField label="Estado Recobro"            value={formatText(d.estadoRecobro)} />
        </SheetGrid>
      </SheetSection>
    </SheetPage>
  );
};

export default Recobro;
